import { IError } from '@checkout/errors';
import { INotification } from '@checkout/notifications';
import { RootState } from '@checkout/state';
import { Field, Form, Formik, FormikActions, InjectedFormikProps } from 'formik';
import { ChangeEvent } from 'react';
import { Fragment } from 'react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormikErrorFocus } from '..';
import { Button, InputField, MembershipHeader, MessageBox, Section } from '../../presentational';
import messages from './../../../i18n/base-en';
import { passwordRecoveryRequest } from './../../../reducers/checkout';
import * as Styles from './PasswordRecoveryForm.scss';
import getValidationSchema from './PasswordRecoveryFormValidationSchema';

interface IOwnProps {
  isFolded: boolean;
  toggleVisibility: (event: ChangeEvent<any>) => void;
}

interface IConnectedProps {
  errors?: IError;
  notifications?: INotification;
}

interface IConnectetDispatchProps {
  passwordRecoveryRequest: typeof passwordRecoveryRequest;
}

interface IFormValues {
  recovery: {
    email: string;
  };
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedFormikProps<IOwnProps, IFormValues> & InjectedIntlProps;

class PasswordRecoveryForm extends React.Component<Props, {}> {

  validationSchema = () => {
    return getValidationSchema(this.props.intl);
  }

  onSubmit = (values: IFormValues, formikBag: FormikActions<IFormValues>) => {
    this.props.passwordRecoveryRequest({ email: values.recovery.email, linkUri: 'forgot' });
  }

  componentDidMount() {
    const loginField = document.getElementById('recovery.email');
    if (loginField) {
      loginField.focus();
    }
  }

  componentDidUpdate() {
    const loginField = document.getElementById('recovery.email');
    if (loginField) {
      loginField.focus();
    }
  }

  render() {
    const { toggleVisibility, isFolded, errors, notifications, intl } = this.props;
    const { formatMessage } = intl;

    return (
      <div className={Styles.form}>
        <MembershipHeader
          title={formatMessage(messages.membership_recovery_password_title)}
          subTitle={formatMessage(messages.membership_recovery_password_subtitle)}
        />
        {!isFolded && (
          <Fragment>
            {errors && errors.uiType === 'inline' && <MessageBox spacingBottom={true} type="error" message={errors.messages[0]} />}
            {notifications && <MessageBox spacingBottom={true} type={notifications.type} message={notifications.messages[0]} />}
            <Formik<IFormValues>
              initialValues={{
                recovery: {
                  email: '',
                }
              }}
              validationSchema={this.validationSchema}
              onSubmit={this.onSubmit}
              render={(formik) => {
                return (
                  <Form className={Styles.form}>
                    <Section>
                      <Field
                        id="recovery.email"
                        name="recovery.email"
                        component={InputField}
                        placeholder={formatMessage(messages.membership_email_placeholder)}
                        label={formatMessage(messages.membership_email_label)}
                        required={true}
                        type="email"
                        submitOnEnter={true}
                      />
                    </Section>
                    <Button
                      type="submit"
                      variant="primary"
                      align="center"
                      size="medium"
                      width="long"
                      label={formatMessage(messages.membership_password_recovery)}
                    />

                    <FormikErrorFocus formikContext={formik} />
                  </Form>
                );
              }}
            />
            <div className={Styles.button}>
              <Button
                onClick={toggleVisibility}
                type="button"
                variant="clear"
                align="center"
                size="medium"
                width="long"
                label={formatMessage(messages.membership_back_to_login)}
              />
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      errors: state.checkout.errors,
      notifications: state.checkout.notifications,
    }),
    {
      passwordRecoveryRequest
    },
  )
)(PasswordRecoveryForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/PasswordRecoveryForm/PasswordRecoveryForm.tsx